<template>
  <Transition
    :css="false"
    @enter="scrollAnimation"
  >
    <div>
      <div class="scf-row">
        <div class="project-detail-breadcrumb scf-row__inner">
          <button
            class="back-button button--transparent button--icon scf-body-s"
            @click="$store.state.targetComponent = project.projectType"
          >
            <svg
              id="back-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                fill="#ffffff66"
                fill-rule="nonzero"
                opacity="1"
                stroke="none"
              />
            </svg>
            Back to {{ project.projectType }} projects
          </button>
        </div>
      </div>
      <section class="project scf-main-margins">
        <div class="scf-row">
          <header class="project-detail-header scf-row__inner">
            <div class="scf-content-block">
              <div class="project-detail-header__title scf-margin-bottom--l">
                <div class="project-detail-header__title--main">
                  <h1
                    class="project-detail-title content-header__project-title scf-heading-l"
                  >
                    {{ project.title }}
                  </h1>
                  <ul class="project-types">
                    <li
                      v-for="(type, index) in $store.getters.getProjectTypes"
                      :key="index"
                      class="project-type"
                    >
                      <div
                        v-if="type === project.projectType"
                        class="button button--selected scf-body-s"
                      >
                        {{ type }}
                      </div>
                      <button
                        v-else-if="project.pairId"
                        class="button button--unselected scf-body-s"
                        @click="
                          $store.state.detailProject = project.pairId;
                          $store.state.targetComponent = 'detailProject';
                        "
                      >
                        {{ type }}
                      </button>
                    </li>
                  </ul>
                </div>
                <ul class="tags">
                  <li
                    v-for="(tag, index) in project.tags"
                    :key="index"
                    class="tag"
                  >
                    {{ tag }}
                  </li>
                </ul>
              </div>
              <div class="project-detail-header__details">
                <div class="project-detail-header__details-inner">
                  <p class="scf-text-and-icon">
                    <svg
                      id="calendar-icon"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 160 160"
                      xml:space="preserve"
                    >
                      <path
                        d="M136 12L120 12L120 8C120 3.6 116.4 0 112 0C107.6 0 104 3.6 104 8L104 12L56 12L56 8C56 3.6 52.4 0 48 0C43.6 0 40 3.6 40 8L40 12L24 12C10.8 12 0 22.8 0 36L0 136C0 149.2 10.8 160 24 160L136 160C149.2 160 160 149.2 160 136L160 36C160 22.8 149.2 12 136 12ZM24 28L40 28L40 32C40 36.4 43.6 40 48 40C52.4 40 56 36.4 56 32L56 28L104 28L104 32C104 36.4 107.6 40 112 40C116.4 40 120 36.4 120 32L120 28L136 28C140.4 28 144 31.6 144 36L144 48L16 48L16 36C16 31.6 19.6 28 24 28ZM136 144L24 144C19.6 144 16 140.4 16 136L16 64L144 64L144 136C144 140.4 140.4 144 136 144Z"
                        fill="#ffffff66"
                        fill-rule="nonzero"
                        opacity="1"
                        stroke="none"
                      />
                      <path
                        d="M120 80L40 80C35.6 80 32 83.6 32 88C32 92.4 35.6 96 40 96L120 96C124.4 96 128 92.4 128 88C128 83.6 124.4 80 120 80Z"
                        fill="#ffffff66"
                        fill-rule="nonzero"
                        opacity="1"
                        stroke="none"
                      />
                      <path
                        d="M88 112L40 112C35.6 112 32 115.6 32 120C32 124.4 35.6 128 40 128L88 128C92.4 128 96 124.4 96 120C96 115.6 92.4 112 88 112Z"
                        fill="#ffffff66"
                        fill-rule="nonzero"
                        opacity="1"
                        stroke="none"
                      />
                    </svg>
                    <span>
                      <em>
                        from: <strong>{{ project.initialDate }}</strong>
                      </em>
                      &nbsp;
                      <em>
                        to: <strong>{{ project.finalDate }}</strong>
                      </em>
                    </span>
                  </p>
                  <p class="scf-text-and-icon">
                    <svg
                      id="briefcase-icon"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 160 160"
                      xml:space="preserve"
                    >
                      <path
                        d="M136 32L112 32L112 18.8C112 8.4 103.6 0 93.2 0L66.2 0C56.2 0 48 8.1 48 18.1C48 24.4 48 28.8 48 32L24 32C10.8 32 0 42.8 0 56L0 136C0 149.2 10.8 160 24 160L136 160C149.2 160 160 149.2 160 136L160 56C160 42.8 149.2 32 136 32ZM64 18.2C64 17 65 16 66.2 16L93.2 16C94.8 16 96 17.3 96 18.8L96 32L63.9 32C63.9 29.5 63.9 25.3 64 18.2ZM24 48L136 48C140.4 48 144 51.6 144 56L144 88L120 88L120 80C120 75.6 116.4 72 112 72C107.6 72 104 75.6 104 80L104 88L80 88L56 88L56 80C56 75.6 52.4 72 48 72C43.6 72 40 75.6 40 80L40 88L16 88L16 56C16 51.6 19.6 48 24 48ZM136 144L24 144C19.6 144 16 140.4 16 136L16 104L40 104L40 112C40 116.4 43.6 120 48 120C52.4 120 56 116.4 56 112L56 104L80 104L104 104L104 112C104 116.4 107.6 120 112 120C116.4 120 120 116.4 120 112L120 104L144 104L144 136C144 140.4 140.4 144 136 144Z"
                        fill="#ffffff66"
                        fill-rule="nonzero"
                        opacity="1"
                        stroke="none"
                      />
                    </svg>
                    employer: <strong>{{ project.employer }}</strong>
                  </p>
                  <p class="scf-text-and-icon">
                    <svg
                      id="group-icon"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 160 160"
                      xml:space="preserve"
                    >
                      <path
                        d="M62.2222 0L8.88889 0C4 0 0 4 0 8.88889L0 62.2222C0 67.1111 4 71.1111 8.88889 71.1111L62.2222 71.1111C67.1111 71.1111 71.1111 67.1111 71.1111 62.2222L71.1111 8.88889C71.1111 4.00001 67.1111 0 62.2222 0ZM53.3333 53.3333L17.7778 53.3333L17.7778 17.7778L53.3333 17.7778L53.3333 53.3333Z"
                        fill="#ffffff66"
                        fill-rule="nonzero"
                        opacity="1"
                        stroke="none"
                      />
                      <path
                        d="M151.111 0L97.7778 0C92.8889 0 88.8889 4 88.8889 8.88889L88.8889 62.2222C88.8889 67.1111 92.8889 71.1111 97.7778 71.1111L151.111 71.1111C156 71.1111 160 67.1111 160 62.2222L160 8.88889C160 4.00001 156 0 151.111 0ZM142.222 53.3333L106.667 53.3333L106.667 17.7778L142.222 17.7778L142.222 53.3333Z"
                        fill="#ffffff66"
                        fill-rule="nonzero"
                        opacity="1"
                        stroke="none"
                      />
                      <path
                        d="M62.2222 88.8889L8.88889 88.8889C4 88.8889 0 92.8889 0 97.7778L0 151.111C0 156 4 160 8.88889 160L62.2222 160C67.1111 160 71.1111 156 71.1111 151.111L71.1111 97.7778C71.1111 92.8889 67.1111 88.8889 62.2222 88.8889ZM53.3333 142.222L17.7778 142.222L17.7778 106.667L53.3333 106.667L53.3333 142.222Z"
                        fill="#ffffff66"
                        fill-rule="nonzero"
                        opacity="1"
                        stroke="none"
                      />
                      <path
                        d="M151.111 88.8889L97.7778 88.8889C92.8889 88.8889 88.8889 92.8889 88.8889 97.7778L88.8889 151.111C88.8889 156 92.8889 160 97.7778 160L151.111 160C156 160 160 156 160 151.111L160 97.7778C160 92.8889 156 88.8889 151.111 88.8889ZM142.222 142.222L106.667 142.222L106.667 106.667L142.222 106.667L142.222 142.222Z"
                        fill="#ffffff66"
                        fill-rule="nonzero"
                        opacity="1"
                        stroke="none"
                      />
                    </svg>
                    team size: <strong>{{ project.teamSize }} members</strong>
                  </p>
                </div>
                <template v-if="project.videos.length">
                  <!-- YouTube video -->
                  <ul class="project-detail-header__videos">
                    <li
                      v-for="(video, index) in project.videos"
                      :key="index"
                      class="project-detail-header__video"
                    >
                      <a
                        :href="video.url"
                        :title="video.title + ' | video #' + (index + 1)"
                        class="button button--icon"
                        target="_blank"
                      >
                        {{ video.title }}
                        <svg
                          id="video-icon"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          viewBox="0 0 310 310"
                          xml:space="preserve"
                        >
                          <path
                            d="M297.917,64.645c-11.19-13.302-31.85-18.728-71.306-18.728H83.386c-40.359,0-61.369,5.776-72.517,19.938
            C0,79.663,0,100.008,0,128.166v53.669c0,54.551,12.896,82.248,83.386,82.248h143.226c34.216,0,53.176-4.788,65.442-16.527
            C304.633,235.518,310,215.863,310,181.835v-53.669C310,98.471,309.159,78.006,297.917,64.645z M199.021,162.41l-65.038,33.991
            c-1.454,0.76-3.044,1.137-4.632,1.137c-1.798,0-3.592-0.484-5.181-1.446c-2.992-1.813-4.819-5.056-4.819-8.554v-67.764
            c0-3.492,1.822-6.732,4.808-8.546c2.987-1.814,6.702-1.938,9.801-0.328l65.038,33.772c3.309,1.718,5.387,5.134,5.392,8.861
            C204.394,157.263,202.325,160.684,199.021,162.41z"
                            fill="#ffffff66"
                            fill-rule="nonzero"
                            opacity="1"
                            stroke="none"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </template>
              </div>
            </div>
          </header>
        </div>
        <div class="parallax scf-content-block">
          <picture
            v-for="(projectGif, index) in project.animGif"
            :key="index"
            class="scf-picture parallax-picture"
            data-depth="1"
          >
            <img
              :src="'./images/projects/' + project.images[0]"
              :alt="project.title + ' | #' + index"
            />
          </picture>
        </div>
        <div class="scf-row">
          <div class="scf-row__inner">
            <!-- introduction -->
            <div
              class="scf-content-block scf-content-block--text"
              v-html="project.introduction"
            ></div>

            <!-- animated gif -->
            <div class="project-detail-content__animated-gif">
              <picture
                v-for="(projectGif, index) in project.animGif"
                :key="index"
                class="scf-picture scf-content-block"
              >
                <img
                  :src="'./images/projects/' + projectGif.gif"
                  :alt="project.title + ' | animated GIF #' + (index + 1)"
                />
              </picture>
            </div>

            <!-- text -->
            <div
              v-for="(projectText, index) in project.textBlocks"
              :key="index"
              class="scf-content-block"
            >
              <h3
                class="scf-heading-s content-header__project-subtitle scf-margin-bottom--m"
              >
                {{ projectText.subtitle }}
              </h3>
              <div
                class="scf-content-block scf-content-block--text"
                v-html="projectText.text"
              ></div>
            </div>

            <!-- photos -->
            <div class="project-detail-content__images scf-content-block">
              <picture
                v-for="(projectImage, index) in project.images"
                :key="index"
                class="scf-picture"
                @click="
                  $store.state.overlayPicture = {
                    index: index,
                    projectTitle: project.title,
                    images: project.images,
                  }
                "
              >
                <img
                  :src="`./images/projects/${projectImage}`"
                  :alt="`${project.title} | image #${index + 1}`"
                />
              </picture>
            </div>

            <template v-if="project.links.length">
              <!-- links -->
              <div class="scf-content-block scf-content-block--link">
                <h3
                  class="scf-heading-s content-header__project-subtitle scf-margin-bottom--m"
                >
                  Links
                </h3>
                <ul>
                  <li
                    v-for="(link, index) in project.links"
                    :key="index"
                    class="scf-link"
                  >
                    <a
                      :href="link.link"
                      :title="link.name + ' | #' + (index + 1)"
                      target="_blank"
                    >
                      {{ link.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </template>
          </div>
        </div>
      </section>
    </div>
  </Transition>
</template>

<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "ProjectDetail",
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  mounted: function () {
    this.scrollAnimation();
  },
  methods: {
    scrollAnimation() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(function () {
        const parallax = document.querySelector(".parallax");
        const parallaxRect = parallax.getBoundingClientRect();
        const parallaxPictureHeight =
          document.querySelector(".parallax-picture").offsetHeight;
        const depth = document.querySelector(".parallax-picture").dataset.depth;
        const movement = (parallaxRect.height - parallaxPictureHeight) * depth;

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".parallax",
            scrub: 0.4,
            pin: false,
            start: "top " + parallax.offsetTop,
            end: "bottom " + parallaxRect.height,
            markers: false,
            invalidateOnRefresh: true,
          },
        });
        tl.to(".parallax-picture", {
          bottom: movement,
          ease: "none",
        });
      }, 900);
    },
  },
};
</script>

<style lang="less" scoped>
  @import "../styles/all.less";

  .scf-project-detail {
    display: flex;
    flex-direction: column;
  }
  .project-detail-breadcrumb {
    display: flex;
    justify-content: flex-end;

    .back-button {
      position: absolute;
      top: 22px;
      right: 20px;
    }
  }
  /* header block */
  .project-detail-header__title {
    display: flex;
    flex-direction: column;

    @media @scf-breakpoints--m {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
    }

    &--main {
      display: flex;
      gap: @scf-space-s;
    }
  }
  .project-types {
    list-style: none;
    display: flex;
    gap: @scf-space-2xs;
    align-items: center;
  }
  .project-detail-header__details {
    border: 1px solid @white-20;
    border-radius: @scf-border-radius;
    padding: @scf-space-sm @scf-space-ml;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  #group-icon,
  #briefcase-icon,
  #calendar-icon,
  #back-icon {
    width: @scf-space-m;
    margin-inline-end: @scf-space-2xs; //8px;
  }
  #video-icon {
    width: @scf-space-ml;
  }
  .project-detail-header__videos {
    list-style: none;
  }

  /* animated gif */
  .project-detail-content__animated-gif {
    .scf-picture img {
      max-height: 220px; // XS
      object-fit: contain;

      @media @scf-breakpoints--s {
        max-height: 390px; // S
      }
      @media @scf-breakpoints--m {
        max-height: 506px; // M + L
      }
      @media @scf-breakpoints--xl {
        max-height: 635px; // XL
      }
      @media @scf-breakpoints--xxl {
        max-height: 764px; // XXL
      }
    }
  }

  /* content block: images */
  .project-detail-content__images {
    display: flex;
    flex-wrap: wrap;
    gap: @scf-space-sm;

    .scf-picture {
      width: 100%;

      @media @scf-breakpoints--m {
        width: calc(50% - 17px);
      }
      @media @scf-breakpoints--l {
        width: calc(33.333% - 17px);
      }
    }
    img {
      border: 1px solid @white-20;
      border-radius: @scf-border-radius;
      &:hover {
        cursor: pointer;
        border-color: @white;
      }
    }
  }

  /* parallax */
  .parallax {
    position: relative;
    border-top: 1px solid @white-20;
    border-bottom: 1px solid @white-20;
    padding-bottom: 66.6666%;
    overflow: hidden;

    @media @scf-breakpoints--m {
      padding-bottom: 33.33333%;
    }
    .parallax-picture {
      position: absolute;
      bottom: -4px;
      left: -50%;
      width: 200%;

      @media @scf-breakpoints--m {
        left: 0;
        width: 100%;
      }
    }
  }
</style>
